// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
  max-width: 100%;
}
.bs-review {
  width: 100%;
}
.bs-empty {
  margin-top: 0.5rem;
}
.bs-empty-msg {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #fafafa;
  border: 1px solid #ededed;
  font-size: 0.85rem;
  color: #a3a3a3;
  margin-bottom: 12px;
}
.bs-empty-icon {
  font-size: 1.1rem;
}
.bs-streams {
  margin-top: 0.5rem;
}
.bs-streams-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.bs-streams-title {
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #a3a3a3;
}
.bs-streams-progress {
  font-size: 0.78rem;
  font-weight: 700;
  color: #16a34a;
}
.bs-sub {
  margin-bottom: 10px;
  padding: 14px;
  border-radius: 12px;
  border: 1px solid #ededed;
  background: #fff;
  transition: border-color 120ms ease, box-shadow 120ms ease;
}
.bs-sub:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}
.bs-sub-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 6px;
}
.bs-sub-info {
  flex: 1;
  min-width: 0;
}
.bs-sub-name {
  font-size: 0.92rem;
  font-weight: 700;
  color: #171717;
  line-height: 1.3;
}
.bs-sub-meta {
  margin-top: 2px;
  font-size: 0.75rem;
  color: #a3a3a3;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.bs-confidence {
  font-weight: 600;
}
.bs-confidence-high {
  color: #16a34a;
}
.bs-sub-amount {
  flex-shrink: 0;
  text-align: right;
}
.bs-sub-amount-value {
  font-size: 1.1rem;
  font-weight: 800;
  color: #16a34a;
  line-height: 1.1;
}
.bs-sub-amount-label {
  font-size: 0.6rem;
  font-weight: 600;
  text-transform: uppercase;
  color: #a3a3a3;
}
.bs-sub-decided {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 6px;
  background: #fafafa;
  margin-top: 8px;
}
.bs-decided-badge {
  font-size: 0.78rem;
  font-weight: 700;
  flex: 1;
}
.bs-decided-include {
  color: #16a34a;
}
.bs-decided-exclude {
  color: #dc2626;
}
.bs-undo-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid #ededed;
  background: #fff;
  font-size: 0.72rem;
  font-weight: 600;
  color: #005ff0;
  cursor: pointer;
  transition: background 120ms ease, border-color 120ms ease;
}
.bs-undo-btn:hover:not(:disabled) {
  background: #fafafa;
  border-color: #005ff0;
}
.bs-undo-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.bs-done-bar {
  margin-top: 14px;
}
.bs-done-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  min-height: 44px;
  padding: 10px 20px;
  border-radius: 12px;
  border: none;
  font-size: 0.88rem;
  font-weight: 700;
  color: #fff;
  background: #005ff0;
  cursor: pointer;
  transition: background 120ms ease, transform 120ms ease, box-shadow 120ms ease;
}
.bs-done-btn:hover:not(:disabled) {
  background: #004fc7;
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(0, 95, 240, 0.2);
}
.bs-done-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  transform: none;
}
.bs-done-summary {
  font-weight: 400;
  font-size: 0.78rem;
  opacity: 0.85;
}
.bs-exclude-all {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #ededed;
}
.bs-exclude-all-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 999px;
  border: 1px solid rgba(220, 38, 38, 0.2);
  background: #fff;
  font-size: 0.78rem;
  font-weight: 600;
  color: #dc2626;
  cursor: pointer;
  transition: background 120ms ease, border-color 120ms ease;
}
.bs-exclude-all-btn:hover:not(:disabled) {
  background: #fef2f2;
  border-color: #dc2626;
}
.bs-exclude-all-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.bs-cancel-exclude {
  display: inline-flex;
  align-items: center;
  margin-top: 8px;
  padding: 4px 12px;
  border-radius: 999px;
  border: 1px solid #ededed;
  background: #fff;
  font-size: 0.75rem;
  font-weight: 600;
  color: #a3a3a3;
  cursor: pointer;
  transition: background 120ms ease;
}
.bs-cancel-exclude:hover:not(:disabled) {
  background: #fafafa;
}
.bs-cancel-exclude:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.bs-txn-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 12px;
  margin-top: 8px;
  font-size: 0.72rem;
  font-weight: 600;
  color: #005ff0;
  cursor: pointer;
  border-radius: 6px;
  background: #fafafa;
  transition: background 120ms ease;
  -webkit-user-select: none;
          user-select: none;
}
.bs-txn-toggle:hover {
  background: #f5f5f5;
}
.bs-txn-chevron {
  display: inline-block;
  font-size: 0.65rem;
  transition: transform 200ms ease;
}
.bs-txn-chevron.bs-txn-open {
  transform: rotate(90deg);
}
.bs-txn-list {
  margin-top: 6px;
  border-radius: 6px;
  border: 1px solid #ededed;
  background: #fafafa;
  max-height: 200px;
  overflow-y: auto;
}
.bs-txn-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 10px;
  border-bottom: 1px solid #ededed;
  font-size: 0.75rem;
  transition: background 120ms ease;
}
.bs-txn-row:last-child {
  border-bottom: none;
}
.bs-txn-row:hover {
  background: #f5f5f5;
}
.bs-txn-date {
  flex-shrink: 0;
  width: 70px;
  color: #a3a3a3;
  font-weight: 600;
}
.bs-txn-payee {
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #171717;
}
.bs-txn-category {
  flex-shrink: 0;
  color: #a3a3a3;
  font-size: 0.7rem;
}
.bs-txn-amount {
  flex-shrink: 0;
  font-weight: 700;
  color: #16a34a;
}
`, "",{"version":3,"sources":["webpack://./src/app/screening-module/income-wizard/phases/stream-phase/stream-types/stream-review-banksync.component.less"],"names":[],"mappings":"AAYA;EAAQ,cAAA;EAAgB,WAAA;EAAa,eAAA;AARrC;AASA;EAAa,WAAA;AANb;AASA;EACE,kBAAA;AAPF;AAUA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AARF;AAWA;EAAiB,iBAAA;AARjB;AAWA;EAAc,kBAAA;AARd;AAUA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AARF;AAWA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AATF;AAYA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AAVF;AAcA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,0DAAA;AAZF;AAcE;EACE,yCAAA;AAZJ;AAgBA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;AAdF;AAiBA;EAAe,OAAA;EAAS,YAAA;AAbxB;AAeA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAbF;AAgBA;EACE,eAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;AAdF;AAiBA;EACE,gBAAA;AAfF;AAkBA;EACE,cAAA;AAhBF;AAmBA;EACE,cAAA;EACA,iBAAA;AAjBF;AAoBA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAlBF;AAqBA;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;AAnBF;AAuBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AArBF;AAwBA;EACE,kBAAA;EACA,gBAAA;EACA,OAAA;AAtBF;AAyBA;EAAsB,cAAA;AAtBtB;AAuBA;EAAsB,cAAA;AApBtB;AAsBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,0DAAA;AApBF;AAsBE;EACE,mBAAA;EACA,qBAAA;AApBJ;AAuBE;EAAa,YAAA;EAAc,mBAAA;AAnB7B;AAuBA;EACE,gBAAA;AArBF;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,8EAAA;AAtBF;AAwBE;EACE,mBAAA;EACA,2BAAA;EACA,4CAAA;AAtBJ;AAyBE;EAAa,aAAA;EAAe,mBAAA;EAAqB,eAAA;AApBnD;AAuBA;EACE,gBAAA;EACA,kBAAA;EACA,aAAA;AArBF;AAyBA;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;AAvBF;AA0BA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,wCAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,0DAAA;AAxBF;AA0BE;EACE,mBAAA;EACA,qBAAA;AAxBJ;AA2BE;EAAa,YAAA;EAAc,mBAAA;AAvB7B;AA0BA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iCAAA;AAxBF;AA0BE;EAAyB,mBAAA;AAvB3B;AAwBE;EAAa,YAAA;EAAc,mBAAA;AApB7B;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,iCAAA;EACA,yBAAA;UAAA,iBAAA;AAtBF;AAwBE;EAAU,mBAAA;AArBZ;AAwBA;EACE,qBAAA;EACA,kBAAA;EACA,gCAAA;AAtBF;AAwBE;EAAgB,wBAAA;AArBlB;AAwBA;EACE,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AAtBF;AAyBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,gCAAA;EACA,kBAAA;EACA,iCAAA;AAvBF;AAyBE;EAAe,mBAAA;AAtBjB;AAuBE;EAAU,mBAAA;AApBZ;AAuBA;EACE,cAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AArBF;AAwBA;EACE,OAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;AAtBF;AAyBA;EACE,cAAA;EACA,cAAA;EACA,iBAAA;AAvBF;AA0BA;EACE,cAAA;EACA,gBAAA;EACA,cAAA;AAxBF","sourcesContent":["@uds-blue-70: #005ff0;\n@uds-green-70: #16a34a;\n@uds-red-70: #dc2626;\n@uds-neutral-10: #fafafa;\n@uds-neutral-20: #f5f5f5;\n@uds-neutral-30: #ededed;\n@uds-neutral-50: #a3a3a3;\n@uds-neutral-100: #171717;\n@uds-radius: 12px;\n@uds-radius-sm: 6px;\n@uds-ease: 120ms ease;\n\n:host { display: block; width: 100%; max-width: 100%; }\n.bs-review { width: 100%; }\n\n// ── Empty state ──\n.bs-empty {\n  margin-top: 0.5rem;\n}\n\n.bs-empty-msg {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 14px;\n  border-radius: @uds-radius;\n  background: @uds-neutral-10;\n  border: 1px solid @uds-neutral-30;\n  font-size: 0.85rem;\n  color: @uds-neutral-50;\n  margin-bottom: 12px;\n}\n\n.bs-empty-icon { font-size: 1.1rem; }\n\n// ── Streams header ──\n.bs-streams { margin-top: 0.5rem; }\n\n.bs-streams-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.bs-streams-title {\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: @uds-neutral-50;\n}\n\n.bs-streams-progress {\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: @uds-green-70;\n}\n\n// ── Sub-stream card ──\n.bs-sub {\n  margin-bottom: 10px;\n  padding: 14px;\n  border-radius: @uds-radius;\n  border: 1px solid @uds-neutral-30;\n  background: #fff;\n  transition: border-color @uds-ease, box-shadow @uds-ease;\n\n  &:hover {\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  }\n}\n\n.bs-sub-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 6px;\n}\n\n.bs-sub-info { flex: 1; min-width: 0; }\n\n.bs-sub-name {\n  font-size: 0.92rem;\n  font-weight: 700;\n  color: @uds-neutral-100;\n  line-height: 1.3;\n}\n\n.bs-sub-meta {\n  margin-top: 2px;\n  font-size: 0.75rem;\n  color: @uds-neutral-50;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.bs-confidence {\n  font-weight: 600;\n}\n\n.bs-confidence-high {\n  color: @uds-green-70;\n}\n\n.bs-sub-amount {\n  flex-shrink: 0;\n  text-align: right;\n}\n\n.bs-sub-amount-value {\n  font-size: 1.1rem;\n  font-weight: 800;\n  color: @uds-green-70;\n  line-height: 1.1;\n}\n\n.bs-sub-amount-label {\n  font-size: 0.6rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: @uds-neutral-50;\n}\n\n// ── Decided state ──\n.bs-sub-decided {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  border-radius: @uds-radius-sm;\n  background: @uds-neutral-10;\n  margin-top: 8px;\n}\n\n.bs-decided-badge {\n  font-size: 0.78rem;\n  font-weight: 700;\n  flex: 1;\n}\n\n.bs-decided-include { color: @uds-green-70; }\n.bs-decided-exclude { color: @uds-red-70; }\n\n.bs-undo-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  border: 1px solid @uds-neutral-30;\n  background: #fff;\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: @uds-blue-70;\n  cursor: pointer;\n  transition: background @uds-ease, border-color @uds-ease;\n\n  &:hover:not(:disabled) {\n    background: @uds-neutral-10;\n    border-color: @uds-blue-70;\n  }\n\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n}\n\n// ── Done button ──\n.bs-done-bar {\n  margin-top: 14px;\n}\n\n.bs-done-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  width: 100%;\n  min-height: 44px;\n  padding: 10px 20px;\n  border-radius: @uds-radius;\n  border: none;\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: #fff;\n  background: @uds-blue-70;\n  cursor: pointer;\n  transition: background @uds-ease, transform @uds-ease, box-shadow @uds-ease;\n\n  &:hover:not(:disabled) {\n    background: darken(@uds-blue-70, 8%);\n    transform: translateY(-1px);\n    box-shadow: 0 4px 14px rgba(0, 95, 240, 0.2);\n  }\n\n  &:disabled { opacity: 0.45; cursor: not-allowed; transform: none; }\n}\n\n.bs-done-summary {\n  font-weight: 400;\n  font-size: 0.78rem;\n  opacity: 0.85;\n}\n\n// ── Exclude entire account ──\n.bs-exclude-all {\n  margin-top: 14px;\n  padding-top: 12px;\n  border-top: 1px solid @uds-neutral-30;\n}\n\n.bs-exclude-all-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  border-radius: 999px;\n  border: 1px solid rgba(220, 38, 38, 0.2);\n  background: #fff;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: @uds-red-70;\n  cursor: pointer;\n  transition: background @uds-ease, border-color @uds-ease;\n\n  &:hover:not(:disabled) {\n    background: #fef2f2;\n    border-color: @uds-red-70;\n  }\n\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n}\n\n.bs-cancel-exclude {\n  display: inline-flex;\n  align-items: center;\n  margin-top: 8px;\n  padding: 4px 12px;\n  border-radius: 999px;\n  border: 1px solid @uds-neutral-30;\n  background: #fff;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: @uds-neutral-50;\n  cursor: pointer;\n  transition: background @uds-ease;\n\n  &:hover:not(:disabled) { background: @uds-neutral-10; }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n}\n\n// ── Transactions collapsible ──\n.bs-txn-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 6px 12px;\n  margin-top: 8px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: @uds-blue-70;\n  cursor: pointer;\n  border-radius: @uds-radius-sm;\n  background: @uds-neutral-10;\n  transition: background @uds-ease;\n  user-select: none;\n\n  &:hover { background: @uds-neutral-20; }\n}\n\n.bs-txn-chevron {\n  display: inline-block;\n  font-size: 0.65rem;\n  transition: transform 200ms ease;\n\n  &.bs-txn-open { transform: rotate(90deg); }\n}\n\n.bs-txn-list {\n  margin-top: 6px;\n  border-radius: @uds-radius-sm;\n  border: 1px solid @uds-neutral-30;\n  background: @uds-neutral-10;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.bs-txn-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 5px 10px;\n  border-bottom: 1px solid @uds-neutral-30;\n  font-size: 0.75rem;\n  transition: background @uds-ease;\n\n  &:last-child { border-bottom: none; }\n  &:hover { background: @uds-neutral-20; }\n}\n\n.bs-txn-date {\n  flex-shrink: 0;\n  width: 70px;\n  color: @uds-neutral-50;\n  font-weight: 600;\n}\n\n.bs-txn-payee {\n  flex: 1;\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: @uds-neutral-100;\n}\n\n.bs-txn-category {\n  flex-shrink: 0;\n  color: @uds-neutral-50;\n  font-size: 0.7rem;\n}\n\n.bs-txn-amount {\n  flex-shrink: 0;\n  font-weight: 700;\n  color: @uds-green-70;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
